export function initProjectBoardDetails() {
    document.addEventListener('DOMContentLoaded', async function () {
        const container = document.getElementById('project-board-details-container');
        
        if (container) {
            const boardId = container.dataset.projectBoardId;
            const sharedInfo = container.dataset.sharedInfo;
            const productCategoryLinks = container.dataset.productCategoryLinks ? JSON.parse(container.dataset.productCategoryLinks) : {};
            const detailsModule = await import('./projectboarddetails.jsx');
            const checkoutEnabled = JSON.parse(container.dataset.checkoutEnabled ?? "true");
            detailsModule.initProjectBoardDetails(
                container, 
                boardId, 
                container.dataset.sharing === '1', 
                sharedInfo, 
                productCategoryLinks, 
                checkoutEnabled);
        }
    });
}